import React from "react";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const data = [
  "EMPAGLIFLOZIN 10MG TABLET",
  "EMPAGLIFLOZIN 25MG TABLET",
  "EMPAGLIFLOZIN 5MG, METFORMIN 500MG TABLET",
  "EMPAGLIFLOZIN 5MG, METFORMIN 850MG TABLET",
  "EMPAGLIFLOZIN 5MG, METFORMIN 1000MG TABLET",
  "EMPAGLIFLOZIN 12.5MG, METFORMIN 500MG TABLET",
  "EMPAGLIFLOZIN 12.5MG, METFORMIN 850MG TABLET",
  "EMPAGLIFLOZIN 12.5MG, METFORMIN 1000MG TABLET",
  "EMPAGLIFLOZIN 10MG, LINAGLIPTIN 5MG TABLET",
  "EMPAGLIFLOZIN 25MG, LINAGLIPTIN 5MG TABLET",
];

function NewLaunches() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <Helmet>
        <title>New Launches | EHL Life Sciences Pvt Ltd</title>
        <meta name="keyword" content="EHL Life Sciences Pvt Ltd" />
        <meta name="description" content="EHL Life Sciences Pvt Ltd" />
      </Helmet>
      <Breadcrumb title="New Launches" t={t} />
      <section className="p-30">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="fisherman-content mt-4">
                <h3>Diabetes Range</h3>
                <div className="rangeList">
                  <ul>
                    {data.map((item, i) => {
                      return (
                        <li key={i}>
                          <Link to="/">{item}</Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NewLaunches;
